package com.iregained.eventapp.components.sections.header.styles

import com.iregained.eventapp.theme.toSitePalette
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*

val NavHeaderStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        Modifier.fillMaxWidth().position(Position.Sticky).top(0.px).zIndex(100)
            .backgroundColor(palette.custom.cardBackground).borderBottom(1.px, LineStyle.Solid, palette.custom.divider)
            .padding(topBottom = 12.px, leftRight = 5.percent).boxShadow(0.px, 4.px, 20.px, color = rgba(0, 0, 0, 0.05))
            .styleModifier { property("backdrop-filter", "blur(8px)") }
    }
}

val NavLinkStyle = CssStyle {
    base {
        val palette = colorMode.toSitePalette()
        Modifier
            .padding(topBottom = 8.px, leftRight = 16.px)
            .borderRadius(8.px)
            .color(palette.custom.darkText)
            .fontWeight(FontWeight.Medium)
            .transition(Transition.of("all", 200.ms))
    }
    hover {
        val palette = colorMode.toSitePalette()
        Modifier
            .backgroundColor(palette.custom.neutralLight)
            .color(palette.custom.brandPrimary)
            .boxShadow(0.px, 4.px, 12.px, color = rgba(0, 0, 0, 0.08))
            .styleModifier { property("transform", "translateY(-2px) scale(1.02)") }
    }
    active {
        Modifier.styleModifier { property("transform", "scale(0.95)") }
    }
}

val ButtonStyle = CssStyle {
    base {
        Modifier
            .transition(
                Transition.of("transform", 200.ms),
                Transition.of("box-shadow", 200.ms)
            )
    }
    hover {
        Modifier
            .styleModifier { property("transform", "translateY(-2px)") }
            // Adds a teal glow matching your Brand Primary color
            .boxShadow(0.px, 8.px, 15.px, color = rgba(0, 128, 128, 0.3))
    }
    active {
        // Scales down slightly when clicked
        Modifier
            .styleModifier { property("transform", "translateY(0px) scale(0.96)") }
            .boxShadow(0.px, 2.px, 5.px, color = rgba(0, 128, 128, 0.4))
    }
}

val SideMenuSlideInAnim = Keyframes {
    from { Modifier.translateX(100.percent) }
    to { Modifier }
}

val HeaderButtonStyle = CssStyle {
    val palette = colorMode.toSitePalette()

    base {
        Modifier
            .backgroundColor(palette.brand.primary)
            .transition(Transition.of("transform", 0.2.s), Transition.of("background-color", 0.2.s))
    }
    hover {
        Modifier
            .backgroundColor(palette.brand.primaryHover)
            .translateY((-1).px) // Lifts the button up slightly
    }
}